import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isZoneRemovalRequestFailure(zone) {
      const state = getState().find(({ zone: { uuid } }) => uuid === zone.uuid);

      return state ? state.request.isFailure : false;
    },
    isZoneRemovalRequestPending(zone) {
      const state = getState().find(({ zone: { uuid } }) => uuid === zone.uuid);

      return state ? state.request.isPending : false;
    },
    isZoneRemovalRequestSuccess(zone) {
      const state = getState().find(({ zone: { uuid } }) => uuid === zone.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
